import { useCallback, useState } from 'react';

import { ACTION_IDLE, ACTION_SUBMITTING, ACTION_DONE, stateFor } from '../recordActionStates';

import approvalActionRequest from './approvalActionRequest';

import { approvalActionErrorMessage } from 'Helpers/errors';

/**
 * Submits one approval action and maps the server's answer to a state the
 * pop-up can render.
 *
 * THE MAPPING ITSELF LIVES IN `recordActionStates`, shared with the
 * work-section detail pop-up, which asks the same two questions of the same
 * kinds of answer. `approvalActionErrorMessage` supplies the wording and
 * nothing else. What is left here is the request and the state it drives.
 */

export default function useApprovalAction({ onSettled } = {}) {
    const [state, setState] = useState(ACTION_IDLE);
    const [message, setMessage] = useState('');

    const reset = useCallback(() => {
        setState(ACTION_IDLE);
        setMessage('');
    }, []);

    const submit = useCallback(
        (type, approve, context) => {
            setState(ACTION_SUBMITTING);
            setMessage('');

            const { method, url, payload } = approvalActionRequest(type, approve, context);

            return axios[method](url, payload)
                .then(() => {
                    setState(ACTION_DONE);
                    onSettled?.(ACTION_DONE);
                })
                .catch((error) => {
                    const next = stateFor(error);

                    setState(next);
                    setMessage(approvalActionErrorMessage(error, $t('This action could not be completed.')));
                    onSettled?.(next);
                });
        },
        [onSettled],
    );

    return { state, message, submit, reset, submitting: state === ACTION_SUBMITTING };
}
